import gql from 'graphql-tag'
export interface CreateUserInput {
  admin: boolean
  email?: string | null
  name: string
}

export interface SelectionOnCreateUser {
  id: string
  email: string | null
  uid: string | null
  roles: Array<UserRole>
  name: string | null
  isConfirmed: boolean
}

export interface CreateUser {
  createUser: SelectionOnCreateUser
}

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export default gql`
  mutation CreateUser($admin: Boolean!, $email: String, $name: String!) {
    createUser(admin: $admin, email: $email, name: $name) {
      id
      email
      uid
      roles
      name
      isConfirmed
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/createUser.tsx